<template>
  <div class="user">
    <!-- <div class="photo">
      <img v-if="companyAvatar" :src="companyAvatar"/>
    </div>
 -->    
    <div class="photo" v-if="companyAvatar" :style="'background-image: url(' + companyAvatar + ')'">
    </div>
    <div class="photo" v-else></div>
    <div class="info">
      <a data-toggle="collapse" @click.prevent="goToSettings" href="#">
        <!-- <a data-toggle="collapse" @click="toggleMenu" href="javascript:void(0)"> -->
           <span>
             {{ companyName }}
          </span>
      </a>
      <div class="clearfix"></div>
      <div>
       <!--  <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <li>
              <a href="javascript:void(0)">
                <span class="sidebar-mini">U</span>
                <span class="sidebar-normal">Users</span>
              </a>
            </li>
            <li>
             <router-link to="/feedback">
                <span class="sidebar-mini">F</span>
                <span class="sidebar-normal">Feedback</span>
              </router-link>
            </li>
            <li>
              <router-link to="/contact">
                <span class="sidebar-mini">C</span>
                <span class="sidebar-normal">Contact Entries</span>
              </router-link>
            </li>
            <li>
              <router-link to="/settings">
                <span class="sidebar-mini">S</span>
                <span class="sidebar-normal">Settings</span>
              </router-link>
            </li>
          </ul>
        </el-collapse-transition> -->
      </div> 
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    data () {
      return {
        isClosed: false,
        companyName: this.$session.get('companyName'),
        companyAvatar: this.$session.get('companyAvatar')
      }
    },
    created () {
      this.$on('companyName', function (name) {
        console.warn('the new name is: ' + name)
        this.companyName = name
      })
    },
    methods: {
      toggleMenu () {
        this.isClosed = !this.isClosed
      },
      goToSettings () {
        this.$session.set('selecetdTab', 'Company Details')
        this.$router.push('/settings')
      }
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/UserMenu.vue